import React from 'react';
import useStyle from './myClassBlock.style';
import { classNames } from '../../../../helpers/style/classNames';

export interface MyClassBlockProps {
  variant: 'classRank' | 'commission' | 'actuQuiz';
  title: string;
  text: string | JSX.Element;
}

export const MyClassBlock = ({ variant, title, text }: MyClassBlockProps) => {
  const classes = useStyle();

  return (
    <div
      className={classNames(
        [classes.root],
        [
          {
            condition: variant === 'classRank',
            classe: classes.rocket
          },
          {
            condition: variant === 'commission',
            classe: classes.euro
          },
          {
            condition: variant === 'actuQuiz',
            classe: classes.bulb
          }
        ]
      )}
    >
      <p className={classes.text}>{title}</p>
      <div className={classNames([classes.text, classes.bold])}>{text}</div>
    </div>
  );
};
